if (!customElements.get('ayne-product-description')) {
  customElements.define('ayne-product-description', class extends HTMLElement {
    connectedCallback() {
      const article = this.querySelector('[data-product-description]');
      const normalize = (text) => text.trim().replace(/\s+/g, ' ').replace(/[:：]\s*$/, '').toLocaleLowerCase('pt-BR');
      const faqHeading = normalize(this.dataset.faqHeading || '');
      if (!article || !faqHeading) return;

      article.querySelectorAll('h2').forEach((heading) => {
        if (normalize(heading.textContent) !== faqHeading) return;
        let current = heading.nextElementSibling;
        while (current && current.tagName !== 'H2') {
          if (current.tagName !== 'H3') {
            current = current.nextElementSibling;
            continue;
          }
          const question = current;
          const answerNodes = [];
          let next = question.nextSibling;
          let valid = true;
          let paragraphs = 0;
          while (next && !(next.nodeType === 1 && /^(H2|H3)$/.test(next.tagName))) {
            if (next.nodeType === 1) {
              if (next.tagName !== 'P') valid = false;
              else paragraphs += 1;
            } else if (next.nodeType === 3 && next.textContent.trim()) {
              valid = false;
            }
            answerNodes.push(next);
            next = next.nextSibling;
          }
          current = next;
          if (!valid || !paragraphs || question.querySelector('a, button, input, select, textarea, details')) continue;

          const details = document.createElement('details');
          details.className = 'ayne-product-details__faq-item';
          const summary = document.createElement('summary');
          const answer = document.createElement('div');
          answer.className = 'ayne-product-details__answer';
          question.before(details);
          summary.append(question);
          answer.append(...answerNodes);
          details.append(summary, answer);
        }
      });
    }
  });
}
